import React from 'react';

export const NavigationLoadingMask = () => {
  return (
    <div
      id="navigation-loading-mask"
      style={{
        display: 'flex',
        minHeight: '100vh',
        minWidth: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: 'white',
      }}
    >
      <div style={{ width: '245px' }} />
      <div style={{ flex: 1 }} />
    </div>
  );
};
